import { render } from "./UtilitiesMgt.vue?vue&type=template&id=147ac20f&scoped=true"
import script from "./UtilitiesMgt.vue?vue&type=script&lang=js"
export * from "./UtilitiesMgt.vue?vue&type=script&lang=js"

import "./UtilitiesMgt.vue?vue&type=style&index=0&id=147ac20f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-147ac20f"]])

export default __exports__